import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";
import { FaEye, FaPencilAlt, FaTrashAlt } from "react-icons/fa";
import GetServiceButton from "./get-service-button";
import { FaCamera, FaRegImage } from 'react-icons/fa';

const DataTable = ({ data, setSelectedId, handleShow,handleShowDelete }) => {
  const [isGetServicesLoading, setIsGetServicesLoading] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };
  const sortedData = React.useMemo(() => {
    if (sortConfig.key) {
      return [...data].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === "asc" ? -1 : 1;
        if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    }
    return data;
  }, [data, sortConfig]);

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow className="bg-primary">
            {[
              { key: "smmpanel_id", label: "ID" },
              { key: "smmpanel_name", label: "Name" },
              { key: "smmpanel_url", label: "Url" },
              { key: "expired", label: "Expired" },
              { key: "trust", label: "Trust" },
              { key: "reading_status", label: "Reading Status" },
            ].map((column) => (
              <TableCell
                key={column.key}
                align="center"
                className="!text-darkTextColor whitespace-nowrap cursor-pointer"
                onClick={() => handleSort(column.key)}
              >
                {column.label}{" "}
                {sortConfig.key === column.key
                  ? sortConfig.direction === "asc"
                    ? "↑"
                    : "↓"
                  : ""}
              </TableCell>
            ))}
            <TableCell align="center" className="!text-darkTextColor">
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedData.map((item) => (
            <TableRow
              key={item.smmpanel_id}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row" align="center">
                {item?.smmpanel_id}
              </TableCell>
              <TableCell align="center">{item?.smmpanel_name}</TableCell>
              <TableCell align="center">
                <a
                  className="inline-block w-full max-w-48 truncate"
                  href={item?.smmpanel_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item?.smmpanel_url}
                </a>
              </TableCell>
              <TableCell align="center">
                {" "}
                <span
                  className={`badge w-24 text-darkTextColor ${item?.expired ? "bg-[#ff6877]" : "bg-[#28a745]"
                    }`}
                >
                  {item?.expired ? "Expired" : "Valid"}
                </span>
              </TableCell>
              <TableCell align="center">
                <span
                  className={`badge w-24 text-darkTextColor ${item?.trust ? "bg-[#28a745]" : "bg-[#ff6877]"
                    }`}
                >
                  {item?.trust ? "Trusted" : "Not trusted"}
                </span>
              </TableCell>
              <TableCell align="center">
                <span
                  className={`badge w-24 text-darkTextColor ${item?.reading_status === "success"
                    ? "bg-[#28a745]"
                    : item?.reading_status === "not_read"
                      ? "bg-[#f7cb73]"
                      : item?.reading_status === "failed" && "bg-[#ff6877]"
                    }`}
                >
                  {item?.reading_status}
                </span>
              </TableCell>
              <TableCell align="center">
                <div className="flex gap-x-10 text-lg items-center justify-center">
                  <Link
                    to={`/Panels/${item?.smmpanel_id}`}
                    color="inherit"
                    underline="none"
                  >
                    <FaEye className="text-[#6c757d]" />
                  </Link>
                  <FaCamera
                    onClick={() => {
                      setSelectedId(item?.smmpanel_id);
                      handleShow();
                    }}
                    className="text-[#d9534f] cursor-pointer"
                  />

                  <Link
                    to={`/Panels/Edit/${item?.smmpanel_id}`}
                    color="inherit"
                    underline="none"
                  >
                    <FaPencilAlt className="text-[#6c757d]" />
                  </Link>
                  <FaTrashAlt
                    onClick={() => {
                      setSelectedId(item?.smmpanel_id);
                      handleShowDelete();
                    }}
                    className="text-[#d9534f] cursor-pointer"
                  />
                  <GetServiceButton
                    id={item?.smmpanel_id}
                    isGetServicesLoading={isGetServicesLoading}
                    setIsGetServicesLoading={setIsGetServicesLoading}
                  />
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DataTable;
